exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width:575px){#responsive-navigation[data-v-833f3920]{background-color:rgba(26,26,26,.9);position:fixed;bottom:0;left:0;right:0}}.first[data-v-833f3920],.last[data-v-833f3920],.next[data-v-833f3920],.previous[data-v-833f3920]{position:relative}.last[data-v-833f3920],.previous[data-v-833f3920]{margin-left:-15px}.next[data-v-833f3920],.previous[data-v-833f3920]{z-index:2}.first[data-v-833f3920],.last[data-v-833f3920]{opacity:.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-833f3920","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app/Pagination.vue
// module id = 1057
// module chunks = 0